/* eslint-disable no-nested-ternary */

import AddOnProducts from '@gameday/common/components/form/Pages/AddOnProducts'
import { isEmpty } from 'lodash'
import { useState } from 'react'
import styled from 'styled-components'

import config from '../../../../constants/config'
import { common, files } from '../../../../constants/endpoints'
import { privateRoutes } from '../../../../constants/routes/routes'
import { getProductsTotalQuantityPerSession } from '../Products/component'

const StyledAddOnProducts = styled.div`
  --custom-primary-color: ${props => props.formSettings.textLinkColour};
`

const AddOnProductsComponent = ({
  registrations,
  memberProducts,
  currentRegistration,
  timezones,
  next,
  formType,
  feeConfigurations,
  paymentGateway,
  formSettings,
  displayPriceAsZero,
  urlParams,
  setValue,
  validateSession,
  createAndValidateSession,
  sessionId,
  addOn,
  userId,
  form,
  startTimer,
  productGroups,
  products,
  isTeamEvent,
  teamFormType,
  team,
  teamData,
  setTeam,
  formInfo,
  ...rest
}) => {
  const [formError, setFormError] = useState(undefined)

  const isTeamRego = isTeamEvent && teamFormType === 'Register A Team'
  const filteredAddOn = isTeamEvent
    ? isTeamRego
      ? {
          products: (addOn.products || []).filter(q => q.isTeamProduct),
          productGroups: addOn.productGroups,
        }
      : {
          products: (addOn.products || []).filter(q => !q.isTeamProduct),
          productGroups: addOn.productGroups,
        }
    : addOn

  const addOnProducts = isTeamRego ? teamData?.teamAddOn : currentRegistration?.newAddOnProducts

  return (
    <StyledAddOnProducts className="addOn-page" formSettings={formSettings}>
      <AddOnProducts
        addOn={filteredAddOn}
        team={team}
        isTeamRego={isTeamRego}
        mainProducts={products}
        mainProductGroups={productGroups}
        formData={{
          birthdate: currentRegistration?.birthdate,
          gender: currentRegistration?.gender,
          memberTypes: currentRegistration?.memberTypes,
          newProducts: currentRegistration?.newProducts,
          newSubEventProducts: currentRegistration?.newSubEventProducts,
          newAddOnProducts: currentRegistration?.newAddOnProducts,
          timezones,
          userId,
          form,
          // biome-ignore lint/complexity/useOptionalChain: TODO
          pageName: (privateRoutes(isTeamEvent).find(r => r.id === 'add') || {}).title || 'Questions',
          objectId: currentRegistration?.relatedMemberProfileId,
          objectName: 'memberProfile',
          application: config.application,
          uploadEndpoint: `api/${files.uploadDirect}`,
          downloadEndpoint: `api/${files.downloadDirect}`,
          subdivisionEndpoint: `api/${common.subdivision}?country={country}`,
          googleApiKey: config.GOOGLE_API_KEY,
        }}
        paidProducts={currentRegistration?.products || []}
        displayPriceAsZero={displayPriceAsZero}
        // eslint-disable-next-line consistent-return
        onSelected={values => {
          const allSessionProds = {
            ...values,
            ...(formType === 'event' && {
              ...currentRegistration?.newProducts,
              ...currentRegistration?.newSubEventProducts,
            }),
          }

          // eslint-disable-next-line no-shadow
          const products = Object.keys(allSessionProds).reduce((a, k) => {
            const purchase = allSessionProds[k] || {}
            if (!purchase.checked) {
              return a
            }
            a.push({
              id: k,
              quantity: Number(purchase.quantity),
              formProductId: Number(purchase.formProductId),
              attributeId: purchase.attributeId,
              attributeValue: purchase.attributeValue,
              optionIds: purchase.optionIds,
            })
            return a
          }, [])

          const session = {
            source: 'Products',
            products,
          }

          const hasSelectedProducts = Object.keys(values).reduce((a, c) => {
            const isChecked = values[c] || {}
            isChecked.checked && a.push(c)
            return a
          }, [])

          if (!isEmpty(hasSelectedProducts)) {
            // eslint-disable-next-line consistent-return
            const validateCallback = response => {
              if (response.success) {
                if (formType === 'membership') {
                  startTimer(true)
                }

                if (isTeamRego) {
                  setTeam({
                    teamAddOn: values,
                  })
                } else {
                  setValue({
                    newAddOnProducts: values,
                  })
                }
                return next()
              }
              setFormError(response.message)
            }

            if (sessionId) {
              return validateSession(
                {
                  ...session,
                  products: getProductsTotalQuantityPerSession(session, registrations, currentRegistration, formType),
                },
                validateCallback
              )
            }
            createAndValidateSession(session, validateCallback)
          } else {
            return next()
          }
        }}
        formType={formType}
        formInfo={formInfo}
        initialValues={addOnProducts || []}
        next={() => {}}
        formError={formError}
        feeConfigurations={feeConfigurations}
        paymentGateway={paymentGateway}
        isTeamEvent={isTeamEvent}
        teamFormType={teamFormType}
        {...rest}
      />
    </StyledAddOnProducts>
  )
}

export default AddOnProductsComponent
